// extracted by mini-css-extract-plugin
module.exports = {"paginationHeader":"AtSearchSections_paginationHeader__biqqc"};